import { useEffect, useRef, useState } from "react";

// Renders a long list in batches; the next batch mounts as the sentinel nears the viewport.
export default function useProgressiveList(items, step = 24, resetKey = "") {
  const [count, setCount] = useState(step);
  const sentinelRef = useRef(null);

  useEffect(() => { setCount(step); }, [resetKey, step]);

  const hasMore = count < items.length;
  useEffect(() => {
    const el = sentinelRef.current;
    if (!el || !hasMore) return undefined;
    const io = new IntersectionObserver(
      (entries) => { if (entries[0].isIntersecting) setCount((c) => c + step); },
      { rootMargin: "600px 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [hasMore, step, count]);

  return { visible: items.slice(0, count), sentinelRef, hasMore };
}
